import React from 'react';

const FieldError = ({ error }) => {
  if (!error) return null;
  return <p className="text-xs text-red-500 mt-1" role="alert">{error}</p>;
};

export default FieldError;
